import React from "react"
import Modali, { useModali } from "modali"
import Calendly from "./Calendly"

const CalendlyModal = ({ children }) => {
  const [completeModal, toggleCompleteModal] = useModali({
    animated: true,
    closeButton: false,
  })

  return (
    <div>
      <div
        onClick={() => {
          toggleCompleteModal()
        }}
      >
        {children}
      </div>

      <Modali.Modal {...completeModal}>
        <Calendly />
      </Modali.Modal>
    </div>
  )
}

export default CalendlyModal
